import { Grid } from "@mui/material";
import * as React from "react";
import styled from "styled-components";
import { useFormContext } from "react-hook-form";
import { BorderedFormGrid } from "../../../Forms/BorderedFormGrid";
import { PdsrEditItem } from "./PdsrEditItem";
import PdsrStateAsChip from "./PdsrState/PdsrStateAsChip";
import { TextFieldInput } from "../../../Forms/TextFieldInput";

const StyledState = styled.div`
  display: flex;
  justify-content: left;
`;

export const PdsrInformationForm = () => {
  const { control } = useFormContext<PdsrEditItem>();
  return (
    <Grid container columnSpacing={1}>
      <Grid item xs={12}>
        <BorderedFormGrid>
          <Grid item xs={2.5}>
            <TextFieldInput
              name="ContainerNetwork"
              label="Container Network"
              control={control}
              disabled
            />
          </Grid>
          <Grid item xs={2.5}>
            <TextFieldInput name="PlantGsdb" label="Plant GSDB" control={control} disabled />
          </Grid>
          <Grid item xs={2.5}>
            <TextFieldInput name="OutboundDock" label="Outbound Dock" control={control} disabled />
          </Grid>
          <Grid item xs={2.5}>
            <TextFieldInput name="SupplierGsdb" label="Supplier GSDB" control={control} disabled />
          </Grid>
          <Grid item xs={2}>
            <StyledState>
              <PdsrStateAsChip name="State" control={control} />
            </StyledState>
          </Grid>
        </BorderedFormGrid>
        <BorderedFormGrid>
          <Grid item xs={2.5}>
            <TextFieldInput name="Comment" control={control} />
          </Grid>
        </BorderedFormGrid>
      </Grid>
    </Grid>
  );
};
